export default __webpack_public_path__ + "static/media/fai_token_logo.96435549.png";